import { createStyles, makeStyles } from '@material-ui/core'
import { GridCellParams, GridColDef, DataGrid, GridSortDirection, GridValueFormatterParams } from '@material-ui/data-grid'
import _ from 'lodash'
import React, { useMemo } from 'react'
import { useHistory } from 'react-router'
import { ContainerSchema } from '../../../Schema/ContainerSchema'
import { formatLocalDateTime } from '../../../Utils/DateFunctions'
import { ContainerTag } from './ContainerTag'
// import { UserTag } from '../UserTag'

const sortModel = [
  {
    field: 'name',
    sort: 'asc' as GridSortDirection,
  },
]

const columns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Name',
    width: 200,
    renderCell: (params: GridValueFormatterParams) => {
      return (
        <ContainerTag containerId={params.getValue(params.id, 'id')?.toString()} />
      )
    },
  },
  {
    field: 'dimensionalLabel',
    headerName: 'Dimensional Label',
    width: 200,
  },
  {
    field: 'dimensionalWeight',
    headerName: 'Dimensional Weight',
    width: 200,
    type: 'number',
  },
  {
    field: 'updated',
    headerName: 'Updated',
    width: 180,
    type: 'dateTime',
    valueFormatter: (params: GridValueFormatterParams) => {
      return formatLocalDateTime(params.getValue(params.id, 'updated') as Date)
    },
  },
  {
    field: 'created',
    headerName: 'Created',
    width: 180,
    type: 'dateTime',
    valueFormatter: (params: GridValueFormatterParams) => {
      return formatLocalDateTime(params.getValue(params.id, 'created') as Date)
    },
  },
]

interface ContainersDataGridProps {
  entities: ContainerSchema[] | Record<string, ContainerSchema>
}

export const ContainersDataGrid: React.FC<ContainersDataGridProps> = ({
  entities,
}) => {
  const history = useHistory()
  const styles = useStyles()

  const [sortModel, setSortModel] = React.useState([
    {
      field: 'name',
      sort: 'asc' as GridSortDirection,
    },
  ])

  const rows: ContainerSchema[] = useMemo(() => {
    return _.map(entities)
  }, [entities])

  const handleOnCellClick = (params: GridCellParams) => {
    /* if (_.includes(['status', 'assigneeId'], cellParams.field)) {
      return
    } */
    history.push(`/settings/containers/${params.getValue(params.id, 'id')}`)
  }

  return (
    <DataGrid
      sortModel={sortModel}
      onSortModelChange={(model) => setSortModel(model)}
      className={styles.grid}
      columns={columns}
      rows={rows}
      showColumnRightBorder
      onCellClick={handleOnCellClick}
    />
  )
}

const useStyles = makeStyles(theme =>
  createStyles({
    grid: {
      fontSize: 14,
    },
  }),
)
